



































































import { Component, Ref, Vue } from 'vue-property-decorator';
import freightEdit from './freightEdit.vue';
import freightLook from './freightLook.vue';
import { freightGoodList, delFreight } from '@/utils/api';
import { success } from '@/utils/find';
@Component({
  components: {
    freightEdit,
    freightLook,
  },
})
export default class freightProduct extends Vue {
  loading: boolean = false; //加载
  tableData: Array<object> = []; //表格数据
  currentPage: number = 1; //当前页面
  total: number = 20; //总条数
  freightTitle: string = '新增单品运费模版'; //修改抽屉title
  lookTitle: string = '查看单品运费模版（非内置）'; //查看抽屉title
  drawer: boolean = false; //修改抽屉是否打开
  lookDrawer: boolean = false; //查看抽屉
  data: object = {}; //传给详情的数据
  looksData: object = {}; //查看数据
  $refs: any;
  created() {
    this.freightGoodList(this.currentPage - 1);
  }
  // 列表
  freightGoodList(page) {
    this.loading = true;
    freightGoodList({
      page: page,
      size: 20,
    })
      .then((data: any) => {
        this.tableData = data.content;
        this.currentPage = data.number + 1;
        this.total = data.totalElements;
      })
      .finally(() => {
        this.loading = false;
      });
  }
  // 删除
  deletes(id) {
    delFreight({
      templateId: id.templateId,
    }).then((data) => {
      success('删除成功');
      this.freightGoodList(this.currentPage - 1);
    });
  }

  // 新增商品
  onSubmit() {
    this.drawer = true;

    this.freightTitle = '新增单品运费模版';
    this.data = { isadd: true, data: { defaulted: 0, templateId: '0' } };
    this.$nextTick(() =>{
      this.$refs['freightEdit'].init();
    })
  }
  // 修改模板
  modify(data) {
    this.drawer = true;
    if (data['defaulted'] == 0) {
      this.freightTitle = '修改单品运费模版（非内置）';
    } else {
      this.freightTitle = '修改单品运费模版（内置）';
    }
    this.data = { data, isadd: false };
  }
  // 查看模板
  look(data) {
    this.lookDrawer = true;
    if (data['defaulted'] == '0') {
      this.lookTitle = '查看单品运费模版（非内置）';
    } else {
      this.lookTitle = '查看单品运费模版（内置）';
    }
    this.looksData = data;
  }
  // 跳转页面
  handleCurrentChange(val) {
    this.freightGoodList(val - 1);
    this.freightGoodList(this.currentPage - 1);
  }
  // 关闭抽屉
  replace(){
    this.drawer=false;
    this.freightGoodList(this.currentPage-1);
    this.data={};
  }
  // 抽屉关闭自调事件
  handleClose(done){
    done();
    this.data={};
  }
}
